<template>
  <div class="home">
    <h3 class="mb-3 text-right">Balance de colocaciones</h3>
    <b-card
      header-tag="header"
      header-class="card-color bord"
      class="mb-4"
      style="border-radius: 15px"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="6">
            <div class="text-left card-title-white">Balances</div>
          </b-col>
          <b-col lg="3" md="3" sm="3" cols="6">
            <b-form-select
              v-model="id_account"
              :options="account"
              size="sm"
              class="shadow-sm rounded"
            ></b-form-select>
          </b-col>
        </b-row>
      </template>

      <b-card-text class="scroll">
        <b-list-group class="p-2" v-if="!id_account">
          <b-list-group-item
            class="flex-column align-items-start"
            style="border-radius: 15px; border-color: #121419"
          >
            Seleccione una cuenta
          </b-list-group-item>
        </b-list-group>
        <b-list-group class="p-2" v-if="balance.length == 0 && id_account">
          <b-list-group-item
            class="flex-column align-items-start"
            style="border-radius: 15px; border-color: #121419"
          >
            No hay balances disponibles
          </b-list-group-item>
        </b-list-group>
      
        <b-list-group class="p-2" v-for="data of balance" :key="data.id">
          <b-list-group-item
            href="#"
            class="flex-column align-items-start"
            style="border-radius: 15px; border-color: #121419"
            @click="modal_description(data.description)"
          >
            <b-row align-v="center" align-h="start">
              <b-col md="1">
                <img src="../assets/LogoSSBG.png" height="50px" alt="" />
              </b-col>
              <b-col md="4">
                <h5 class="mb-1 text-font-black" style="font-size: 18px">
                  {{
                    data.created_at.substr(5, 2) == "01"
                      ? "Enero"
                      : data.created_at.substr(5, 2) == "02"
                      ? "Febrero"
                      : data.created_at.substr(5, 2) == "03"
                      ? "Marzo"
                      : data.created_at.substr(5, 2) == "04"
                      ? "Abril"
                      : data.created_at.substr(5, 2) == "05"
                      ? "Mayo"
                      : data.created_at.substr(5, 2) == "06"
                      ? "Junio"
                      : data.created_at.substr(5, 2) == "07"
                      ? "Julio"
                      : data.created_at.substr(5, 2) == "08"
                      ? "Agosto"
                      : data.created_at.substr(5, 2) == "09"
                      ? "Septiembre"
                      : data.created_at.substr(5, 2) == "10"
                      ? "Octubre"
                      : data.created_at.substr(5, 2) == "11"
                      ? "Noviembre"
                      : data.created_at.substr(5, 2) == "12"
                      ? "Diciembre"
                      : "No hay fecha"
                  }}
                  {{ data.created_at.substr(0, 4) }}
                </h5>
                <p class="mb-1 text-light-black" style="font-size: 13px">
                  <strong>{{ data.account.name }}</strong>
                </p>
                <div
                class="text-bold-black-title text-center"
                style="font-size: 11px"
              >
                {{data.status.name}}
              </div>
              
              <div
                class="text-bold-black-title text-center"
                style="font-size: 11px"
              >
                {{ data.created_at }}
              </div>
              </b-col>
              <b-col md="4"></b-col>
              <b-col md="1" v-if="data.type_money_flow == 1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  enable-background="new 0 0 24 24"
                  height="35px"
                  viewBox="0 0 24 24"
                  width="35px"
                  fill="#27C249"
                >
                  <rect fill="none" height="24" width="24" />
                  <path
                    d="M19.71,9.71L22,12V6h-6l2.29,2.29l-4.17,4.17c-0.39,0.39-1.02,0.39-1.41,0l-1.17-1.17c-1.17-1.17-3.07-1.17-4.24,0L2,16.59 L3.41,18l5.29-5.29c0.39-0.39,1.02-0.39,1.41,0l1.17,1.17c1.17,1.17,3.07,1.17,4.24,0L19.71,9.71z"
                  />
                </svg>
              </b-col>
              <b-col md="1" v-if="data.type_money_flow == 2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="35px"
                  viewBox="0 0 24 24"
                  width="35px"
                  fill="#D91414"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
                  />
                </svg>
              </b-col>
              <b-col md="2">
              <h5
                class="mb-1 text-font-black text-right"
                style="font-size: 30px"
              >
                <span v-if="data.type_money_flow == 2">-</span> $ {{ data.amount }}
              </h5>
              <div class="mb-1 text-light-black-title text-right" style="font-size: 15px" v-if="data.accumulated_amount">
                    $ {{data.accumulated_amount}} <!-- <span v-if="history.status.id == 1"> - Pendiente: $ {{ history.account.overview.pending_incomes }}</span> --> 
                  </div>
            </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-card-text>
    </b-card>
    <b-modal
      id="modal-description"
      ref="modal"
      title-class="text-font-black"
      title="Descripción del balance"
      hide-footer
      footer-class="text-font-black"
    >
      <b-container>
        <b-row>
          <b-col>
            <p style="font-family: Montserrat; font-size: 14px">
              {{ description }}
            </p>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

export default {
  name: "Home",
  data() {
    return {
      id: Cookies.get("id"),
      balance: [],
      description: null,
      amount: 0,
      account: [{ value: null, text: "Seleccione una cuenta" }],
      id_account: null,
      update: null,
    };
  },
  mounted() {
    this.AllAccount();
  },
  methods: {
    ...mapActions([
      "getAccountForBalance",
      "EarnLostBalance",
      "getBalanceAccount",
    ]),
    modal_description(data) {
      this.description = data;
      this.$nextTick(() => {
        this.$bvModal.show("modal-description");
      });
    },
    AllAccount() {
      this.getAccountForBalance(this.id)
        .then((response) => {
          if (response.code == 200) {
            response.data.forEach((element) => {
              this.account.push({
                value: String(element.id),
                text: element.name,
              });
            });
            if (this.$route.path.substr(9, 10)) {
              this.id_account = this.$route.path.substr(9, 10);
              this.AllBalance();
            }
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    AllBalance() {
      console.log(this.id_account);
      this.EarnLostBalance(this.id_account)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.balance = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
      /* this.getBalanceAccount(this.id_account)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.amount = response.data.balance;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        }); */
    },
  },
  updated() {
    if (this.id_account != null && this.id_account != this.update) {
      this.update = this.id_account;
      console.log("Balance");
      this.AllBalance();
    } else if (this.id_account == null && this.update != null) {
      this.balance = [];
      this.update = this.id_account;
    }
  },
};
</script>
<style scoped>
.scroll {
  overflow: auto;
  overflow-x: hidden;

  max-height: 400px;
}
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
</style>